import { IdentityUserView, OtpChallengeView } from 'api';
import { useEffect, useState } from 'react';
import { CodeForm } from './components/CodeForm';
import { EmailForm } from './components/EmailForm';

type Props = {
  title: string;
  useCognitoOtpLogin: boolean;
  onGoBack: VoidFunction;
  onLoginSuccess?: (info: IdentityUserView) => void;
  children: (userInfo: IdentityUserView) => JSX.Element;
};

export function LoginForExistingUser({ title, useCognitoOtpLogin, onGoBack, onLoginSuccess, children }: Props) {
  const [submittedEmail, setSubmittedEmail] = useState<string>();
  const [codeChallengeData, setCodeChallengeData] = useState<OtpChallengeView>();
  const [userInfo, setUserInfo] = useState<IdentityUserView>();

  useEffect(() => {
    if (userInfo) {
      onLoginSuccess?.(userInfo);
    }
  }, [onLoginSuccess, userInfo]);

  if (!submittedEmail) {
    return (
      <EmailForm
        title={title}
        useCognitoOtpLogin={useCognitoOtpLogin}
        onGoBack={onGoBack}
        onSubmit={(email, otpData) => {
          setSubmittedEmail(email);
          setCodeChallengeData(otpData);
        }}
      />
    );
  }

  if (submittedEmail && !userInfo) {
    return (
      <CodeForm
        title={title}
        submittedEmail={submittedEmail}
        otpData={codeChallengeData}
        useCognitoOtpLogin={useCognitoOtpLogin}
        onSubmit={(data) => {
          setUserInfo(data);
        }}
        onGoBack={() => {
          setSubmittedEmail(undefined);
        }}
      />
    );
  }

  if (userInfo) {
    return children(userInfo);
  }

  return null;
}
